export const NestedPaths = {
  organizations: 'organizations',
  overview: 'overview',
}
